define('Components/StatusComeInWidget/js/models/StatusComeInWidgetInstanceModel',['underscore','backbone','WidgetInstanceModel','app'],function(_,Backbone,WidgetInstanceModel,app){

    var StatusComeInModel = Backbone.Model.extend({

    });

    return WidgetInstanceModel.extend({
        name:'StatusComeInWidgetModel',
        getActive:function (id) {
            if (this.isActive(id))
            {
                return "active"
            }else
            {
                return "";
            }
        },
        isActive:function (id)
        {
           if (app.getCustomer().getSegment() == id)
           {
               return true;
           }else
           {
               return false;
           }
        }
    })
});
